import React from 'react'
import { Button } from 'components/ui'

import { FaEllipsisH, FaEllipsisV } from 'react-icons/fa'

const EllipsisButton = (props) => {
    const { shape = 'circle', variant = 'plain', size = 'xs',direction="horizontal" } = props

    return (
        <Button
            shape={shape}
            variant={variant}
            size={size}
            icon={direction === "horizontal" ? <FaEllipsisH /> : <FaEllipsisV />}
            {...props}
        />
    )
}

export default EllipsisButton
